<i18n>
{
  "en": {
    "managedIcon": "Managed Point of Sale"
  },
  "es": {
    "managedIcon": "Restaurante gestionado"
  }
}
</i18n>
<template>
  <v-card class="d-flex flex-column align-center clickable ma-2" :style="customWidth"
          v-on="$listeners">
    <v-card-title class="overflow body-1">{{ name }}
      <v-tooltip top v-if="icon">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" :color="icon.color">
            {{ icon.value }}
          </v-icon>
        </template>
        <span>{{ $t('managedIcon') }}</span>
      </v-tooltip>
    </v-card-title>
    <v-progress-circular :rotate="270" :size="90" :width="7" :value="value" color="primary"
                         class="mb-3">
      <div class="font-weight-bold text-h5 ml-2">{{ value }}%</div>
    </v-progress-circular>
  </v-card>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class CompletionByPosWidget extends Vue {
  @Prop({ type: Number, required: true }) value;

  @Prop({ type: String, required: true }) name;

  @Prop({ type: Object, required: false }) icon;

  get customWidth() {
    const width = this.$vuetify.breakpoint.mdAndUp ? '250px' : '200px';
    return { width };
  }
}
</script>
<style scoped>
.clickable {
  cursor: pointer;
}

.overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
